__turbopack_context__.v({
  "btn": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn",
  "btn-alt": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-alt",
  "btn-default": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-default",
  "btn-default-dark-bg": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-default-dark-bg",
  "btn-disabled": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-disabled",
  "btn-elite": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-elite",
  "btn-gold": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-gold",
  "btn-lg": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-lg",
  "btn-link": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-link",
  "btn-plat": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-plat",
  "btn-primary": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-primary",
  "btn-sm": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-sm",
  "btn-success": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-success",
  "btn-warning": "AddSpouseCheckbox-module-scss-module__Bsb4QW__btn-warning",
  "checkboxLabelSlider": "AddSpouseCheckbox-module-scss-module__Bsb4QW__checkboxLabelSlider",
  "container": "AddSpouseCheckbox-module-scss-module__Bsb4QW__container",
  "disabled": "AddSpouseCheckbox-module-scss-module__Bsb4QW__disabled",
  "elegantStyling": "AddSpouseCheckbox-module-scss-module__Bsb4QW__elegantStyling",
  "savings": "AddSpouseCheckbox-module-scss-module__Bsb4QW__savings",
});
